import moment from "moment";

const initialState = {
  startDate: moment().subtract(29, "days").startOf("day").valueOf(),
  endDate: moment().endOf("day").valueOf(),
  interval: "Last 30 Days"
};
/**
 * teporary save the state of passwords if user change his password
 * @param {object} state
 * @param {object} action
 */

const globalFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
      case "SET_START_DATE":
      return { ...state, startDate: action.payload.startDate };

      case "SET_END_DATE":
      return { ...state, endDate: action.payload.endDate };

      case "SET_INTERVAL":
      return { ...state, interval: action.payload.interval };

    case "RESET_GLOBAL_FILTERS":
      return { ...state, ...initialState };

    default:
      return state;
  }
};

export default globalFiltersReducer;
